import { internalCustomerAdminActionTypes as actionTypes } from "../../ActionTypes/InternalCustomerAdmin/internalCustomerAdminActionTypes";

const initialState = {
}
export default function InternalCustomerAdminReducer(state = { ...initialState }, action) {

    let newState = { ...state };

    switch (action.type) {
        case actionTypes.STORE_TERMINATION_REASONS:
            newState.terminationReasons = action.data;
            break;
        case actionTypes.STORE_SKYNET_TERMINATION_REASONS:
            newState.skynetTerminationReasons = action.data;
            break;
        case actionTypes.STORE_SERVICES:
            newState.services = action.data;
            break;
        case actionTypes.STORE_EVENT_LOGS:
            newState.eventLogs = action.data
            break;
        case actionTypes.STORE_EMAIL_DELIVERY_LOGS:
            newState.emailDeliveryLogs = action.data
            break;
        case actionTypes.CLEAR:
            delete newState[action.key];
            break;
        default:
            return state;
    }

    return newState;
}
